import LinkViewV2 from '~/features/chatbotV2/components/linkView'
import SimpleV2 from '~/features/chatbotV2/components/simple'
import { EChatbotTheme } from '~/features/settings/models'
import { store } from '~/store'

// v1 (features/chatbot's own LinkView/Simple top-level render, and the
// chatbotVersion platform-wide kill switch that used to gate between them)
// has been fully removed — chatbot-v2 is now unconditionally the only
// render path. See heyLibbyChatbotFunction's retirement for the backend
// half of this.
function ChatBotPage() {
  const chatbotTheme = store((state) => state.chatbot.layout.selection.theme)

  switch (chatbotTheme) {
    case EChatbotTheme.linkView:
      return <LinkViewV2 />
    case EChatbotTheme.simple:
      return <SimpleV2 />
    default:
      return <LinkViewV2 />
  }
}

export default ChatBotPage
